import date from 'date-and-time';

import { DetailRow } from './DetailRow';
import useFault from '../../data/fault/useFault';
import { Card } from '../../components/base/Card';
import { SectionLoading } from '../shared/SectionLoading';
import {
  FaultDefinitionCategory,
  FaultDefinitionCategoryNames,
} from '../../types/Fault/FaultDefinition';
import { useMemo } from 'react';
import {
  BoltIcon,
  GlobeAltIcon,
  PhoneIcon,
  QuestionMarkCircleIcon,
  WrenchIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';

interface FaultDetailsProps {
  faultDefinitionId: string;
  lastOccurred?: Date;
}

export function FaultDetails({
  faultDefinitionId,
  lastOccurred,
}: FaultDetailsProps) {
  const { fault: faultRecord } = useFault(faultDefinitionId);

  const fault = useMemo(
    () => (faultRecord.data ? faultRecord.data[0] : null),
    [faultRecord.data]
  );

  //Might need to include the notification here

  const iconClasses = 'h-16 w-16 mr-4 text-gray-600 dark:text-gray-400';

  const getCategoryIcon = (category: FaultDefinitionCategory) => {
    switch (category) {
      case FaultDefinitionCategory.Mechanical:
        return <WrenchScrewdriverIcon className={iconClasses} />;
      case FaultDefinitionCategory.Electrical:
        return <BoltIcon className={iconClasses} />;
      case FaultDefinitionCategory.Communications:
        return <PhoneIcon className={iconClasses} />;
      case FaultDefinitionCategory.Environmental:
        return <GlobeAltIcon className={iconClasses} />;
      case FaultDefinitionCategory.Maintenance:
        return <WrenchIcon className={iconClasses} />;
      default:
      case FaultDefinitionCategory.None:
        return <QuestionMarkCircleIcon className={iconClasses} />;
    }
  };

  const classProps = {
    containerClasses: 'sm:grid sm:grid-cols-5 sm:gap-4',
    leftColClasses: '',
    rightColClasses: 'sm:col-span-4',
  };

  return (
    <Card className="lg:col-span-4 space-y-4">
      {faultRecord.isLoading ? (
        <SectionLoading size="sm" />
      ) : (
        <>
          <div className="flex flex-row items-center mb-6 space-x-4">
            {getCategoryIcon(fault?.category ?? FaultDefinitionCategory.None)}
            <span className="text-3xl font-bold">{fault?.code}</span>
            <span className="text-3xl">|</span>
            <span className="text-2xl font-medium">{fault?.title}</span>
          </div>
          <dl className="divide-y divide-gray-100 dark:divide-white/10">
            {/* <DetailRow title="Fault Code" value={fault?.code} /> */}
            <DetailRow
              title="Category"
              value={
                fault?.category
                  ? FaultDefinitionCategoryNames[fault?.category]
                  : undefined
              }
              {...classProps}
            />
            {/* <DetailRow title="Title" value={fault?.title} /> */}
            <DetailRow
              title="Description"
              value={fault?.description}
              {...classProps}
            />
            <DetailRow
              title="Last Occurred"
              value={
                lastOccurred
                  ? date.format(lastOccurred, 'DD/MM/YYYY HH:mm:ss')
                  : undefined
              }
              {...classProps}
            />
          </dl>
        </>
      )}
    </Card>
  );
}
